import { ArticleMedia } from 'designsystem/components/2-molecules/Article';
import { ConvertToPictureObject } from 'designsystem/utilities/convertToPictureObject';
import { imageHeightConverter } from 'designsystem/utilities/imageHeightConverter';
import { imageWidthConverter } from 'designsystem/utilities/imageWidthConverter';
import { BackgroundContainerFeature } from 'features/Modules/BackgroundContainer';
import { useEffect, useState } from 'react';
import { useCentralStore } from 'store';
import { ImageFeature } from '../Image/ImageFeature';

export const ArticleMediaFeature = ({ content, settings, noBackground = false, spacing = true }: Content.ArticleMedia) => {
	const { caption, picture } = content?.properties ?? {};
	const {
		disableCropping = false,
		sizeTypeIsWidth,
		width,
		height = 'Medium',
		position,
		verticalPosition,
		noTopMargin,
		hideImageOnSmallScreens,
	} = settings?.properties ?? {};

	const pictureObject = ConvertToPictureObject(picture);

	const { isMobile } = useCentralStore();

	const [cropImageHeight, setCropImageHeight] = useState<number>(0);
	const [cropImageWidth, setCropImageWidth] = useState<number>(0);
	const [isFullWidth, setIsFullWidth] = useState<boolean>(true);
	const [pictureHeight, setPictureHeight] = useState<number>();

	useEffect(() => {
		if (sizeTypeIsWidth === true) return;
		const displayedHeight = imageHeightConverter(height as UI.ImageHeight);
		setCropImageHeight(displayedHeight);
		setPictureHeight(height == '' ? 400 : displayedHeight);
	}, [height, sizeTypeIsWidth]);

	useEffect(() => {
		if (sizeTypeIsWidth === false || pictureObject?.aspectRatio === null) return;
		const displayedWidth = imageWidthConverter(width as UI.ImageWidth);
		setCropImageWidth(displayedWidth);
		setCropImageHeight(displayedWidth * pictureObject?.aspectRatio);
		setIsFullWidth(false);
	}, [pictureObject?.aspectRatio, sizeTypeIsWidth, width]);

	useEffect(() => {
		if (disableCropping === false || pictureObject?.aspectRatio === null) return;
		const displayedHeight = imageHeightConverter(height as UI.ImageHeight);
		setCropImageWidth(displayedHeight / pictureObject?.aspectRatio);
	}, [disableCropping, height, pictureObject?.aspectRatio]);

	useEffect(() => {
		if (disableCropping === false) return;
		setIsFullWidth(false);
	}, [disableCropping]);

	return hideImageOnSmallScreens && isMobile ? null : (
		<BackgroundContainerFeature enableBackground={!noBackground} noTopMargin={noTopMargin}>
			<ArticleMedia
				caption={caption}
				image={
					<ImageFeature
						altText={pictureObject?.altText}
						aspectRatio={pictureObject?.aspectRatio}
						focalPoint={pictureObject?.focalPoint}
						height={cropImageHeight}
						hideImageOnSmallScreens={hideImageOnSmallScreens}
						isCover={disableCropping === false}
						isFullWidth={isFullWidth}
						pictureHeight={pictureHeight}
						sizes={cropImageWidth === 0 ? '(max-width: 1420px) 100vw, 1400px' : `${cropImageWidth}px`}
						url={pictureObject?.url}
						width={cropImageWidth}
					/>
				}
				width={sizeTypeIsWidth === true ? (width === '' ? undefined : width) : null}
				position={!position ? 'Left' : position}
				verticalPosition={!verticalPosition ? 'Top' : verticalPosition}
				spacing={spacing}
			/>
		</BackgroundContainerFeature>
	);
};
